window.allReports = [];
window.selectedReport;
window.elementType;
window.selectedChartsBulk = [];
window.selectedChartFromUI = [];
window.tempV;
window.chartsWithReportIds = [];

window.MultiEdit = function () {
	var selectedSettings = {};

	function multiEditAsDialog() {

		// check if there is a history and hide button if history doesn't exists
		MultiEdit.ResetSelections();
		MultiEdit.SetupType();
		MultiEdit.BindControls();

		$.when(getHistoryHtml()).done(function (result) {
			if (result.d.length > 0) {
				$("#DUI-ST-MULTIEDIT-HISTORY").show();
			}
			else $("#DUI-ST-MULTIEDIT-HISTORY").hide();
		});
		MultiEdit.ReadSettingsSelection();

		$('#btnMultiEditSave').attr('disabled', true);
		$("#multiEditTabs").tabs("destroy");
		$("#multiEditTabs").removeClass("ui-widget");
		$("#multiEditTabs").tabs();

		$('html').addClass('DUISetup-lock');
		$("#multiEditContainer").css('display', 'block').addClass('DUISetupOuter DUISetupOverlay');
		$("#multiEditCustomSelection").click();
	}

	function multiEditClose() {
		$("#multiEditContainer").css('display', 'none').removeClass('DUISetupOuter DUISetupOverlay');
		//clear all global variables
		window.selectedChartFromUI = "";
	}

	function historyClose() {
		$('.DUI-WINDOW-CLOSE').click();
	}

	function setupType(settingsType) {
		if (settingsType) {
			switch (settingsType) {
				case 'optional filters':
					$('#multiEditOptionalFilters').show();
					break;
				case 'hierarchical filters':
					$('#multiEditHFilters').show();
					break;
			}
		} else {
			var curEditBox = $('.layoutElementAdminFocused');
			var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(curEditBox.attr('guid'));
			var layoutElementType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
			var itemTypes = Storyboard.Constants.itemTypes;
			window.elementType = parseInt(layoutElementType);
			switch (layoutElementType) {
				case itemTypes.CHART:
					$('#multiEditChart .multiEdit-simpleTable').css('display', 'none');
					$('#multiEditChart .multiEdit-chart').css('display', '');
					$('#multiEditChart .multiEditLayoutGroup .settingsFieldset:not(.multiEdit-chart)')
                        .appendTo($('#multiEditRespondentTable .multiEditLayoutGroup'));
					$('#multiEditChart').show();
					break;
				case itemTypes.SIMPLETABLE:
					$('#multiEditChart .multiEdit-chart').css('display', 'none');
					$('#multiEditChart .multiEdit-simpleTable').css('display', '');
					$('#multiEditChart .multiEditLayoutGroup').append($('#multiEditRespondentTable .multiEditLayoutGroup .settingsFieldset'));
					$('#multiEditChart').show();
					break;
				case itemTypes.RESPONDENTTABLE:
					$('#multiEditChart .multiEditLayoutGroup .settingsFieldset:not(.multiEdit-chart)')
                        .appendTo($('#multiEditRespondentTable .multiEditLayoutGroup'));
					$('#multiEditRespondentTable').show();
					break;
				case itemTypes.TABLE:
					$('#multiEditCrossTable').show();
					break;
				case itemTypes.TEXT:
					$('#multiEditText').show();
					break;
			}
		}
	}

	function bindControls() {

		// Select all / Unselect all
		function enableDisableBtn() {
			MultiEdit.ReadSettingsSelection();

			if (!$.isEmptyObject(selectedSettings) && window.selectedChartFromUI.length > 0) {
				$('#btnMultiEditSave').removeAttr('disabled');
			} else {
				$('#btnMultiEditSave').attr('disabled', true);
			}
		}

		$('.chkMultiEditSelectAllGroup').unbind('click').bind('click', function (evt) {
			evt.stopPropagation();
			if ($(this).is(':checked')) {
				$(this).closest('.multiEditSettingsGroup').find('.multiEditSettingsFieldset input[type="checkbox"]').each(function () {
					if ($(this).closest(".multiEditSettingsFieldset ").css('display') != 'none')
						$(this).attr('checked', true);
				});
			} else {
				$(this).closest('.multiEditSettingsGroup').find('.multiEditSettingsFieldset input[type="checkbox"]').removeAttr('checked');
			}
			enableDisableBtn();
		});

        $('.multiEditSettingsGroup').delegate('#multiEdit_chartstyle_series_pointWidth', 'click', function () {
            $(this).siblings('#multiEdit_chkAutoSeriesPointWidth').attr('checked', $(this).attr('checked'));
        });

        $('.multiEditSettingsGroup').delegate('input.hasColorPlaceholder', 'click', function () {
            $(this).siblings('.colorPlaceholder').attr('checked', $(this).attr('checked'));
        });

		$('.settingsFieldsetCheckAll').unbind('click').bind('click', function (evt) {
			evt.stopPropagation();
			if ($(this).is(':checked')) {
				$(this).closest(".multiEditSettingsFieldset").find('input[type="checkbox"]').attr('checked', true);
			} else {
				$(this).closest(".multiEditSettingsFieldset").find('input[type="checkbox"]').removeAttr('checked');
				$(this).closest('.multiEditSettingsGroup').find('.chkMultiEditSelectAllGroup').removeAttr('checked');
			}
			enableDisableBtn();
		});

		$('.multiEditSettingsList input').unbind('click').bind('click', function () {
			if (!$(this).is(':checked')) {
				$(this).closest('.multiEditSettingsList').prev().find('input[type="checkbox"]').removeAttr('checked');
				$(this).closest('.multiEditSettingsGroup').find('.chkMultiEditSelectAllGroup').removeAttr('checked');
			}
			enableDisableBtn();
		});

		// Objects selection

		$('#multiEditObjects input[name=multiEditObjectsSelection]:radio').unbind('change').bind('change', function () {
			var val = $("#multiEditObjects input[name=multiEditObjectsSelection]:checked").val();
			$('.multiEditSelectReports, .multiEditSelectCharts').toggle(val === "CustomSelection");
			//Add code for hiding/showing apply button
			if (val !== "CustomSelection") {
				window.selectedChartFromUI = "-99";
			} else {
				window.selectedChartFromUI = "";
				$('#multiEditCharts').html('').DUIsmartSelectBox('update');
				$('#multiEditReports').DUIsmartSelectBox("select", '');
			}
			enableDisableBtn();
		});

		var reportsSelect = $('#multiEditReports');
		var chartsSelect = $('#multiEditCharts');

		if (reportsSelect.hasClass('DUIsmartSelectBox'))
			reportsSelect.DUIsmartSelectBox('destroy');

		if (chartsSelect.hasClass('DUIsmartSelectBox'))
			chartsSelect.DUIsmartSelectBox('destroy');

		reportsSelect.DUIsmartSelectBox({
			'filter': true,
			'checkable': false,
			'height': 339,
			'width': 259,
			//'singleSelect': true
		});

		chartsSelect.DUIsmartSelectBox({
			'filter': true,
			'checkable': false,
			'height': 340,
			'width': 260
		});

		//clear charts
		$('#multiEditCharts').html('').DUIsmartSelectBox('update');

		if (reportsSelect.hasClass('DUIsmartSelectBox'))
			reportsSelect.DUIsmartSelectBox('destroy');
		reportsSelect.DUIsmartSelectBox({
			'filter': true,
			'checkable': false,
			'height': 339,
			'width': 259,
			//'singleSelect': true
		});
		var layoutGrid = Storyboard.LayoutDesigner.getLayoutGrid();
		Helpers.perfJSonCall({
			method: 'GetReportListForImportSlides',
			data: {
				layoutType: layoutGrid.layoutType,
				backgroundSlides: $(".bgSlideActive").length > 0
			},
			message: 'Retrieving list of reports...',
			successCallback: function (reports) {
				var repOptions = '';

				for (var report in reports)
					if (reports.hasOwnProperty(report)) {
						var displayString = reports[report].DisplayString.trim();
						if (displayString.slice(-1) == "/")
							displayString = displayString.substring(0, displayString.length - 1);
						repOptions += '<option  value="' + reports[report].ReportID + '">' + displayString + '</option>';
						window.allReports.push({
							id: reports[report].ReportID,
							name: displayString
						});
					}
				reportsSelect.html(repOptions).DUIsmartSelectBox('update');
			}
		});


		reportsSelect.live('selected', function () {


			$('#btnMultiEditSave').attr('disabled', false);
			var repId = $(this).DUIsmartSelectBox('selected').toString();
			var selectedReport = repId;
			window.selectedChartFromUI = "";
			$('#btnMultiEditSave').attr('disabled', true);
			if (selectedReport != "") {
				Helpers.perfJSonCall({
					method: 'GetChartsForReport',
					data: {
						reportIds: repId
					},
					message: 'Retrieving charts...',
					successCallback: function (charts) {
						var chartOptions = '';
						var temp = [];

						for (var i in charts) {
							for (var j in charts[i]) {
								window.chartsWithReportIds[charts[i][j].layoutElementId] = i;
							}
						}

						for (var k in charts) {
							for (var l in charts[k])
								temp.push(charts[k][l].layoutElementId);
						}
						var currentChart = parseInt($('.layoutElementAdminFocused').attr("layoutelementid"));
						if (currentChart !== undefined) {
							for (var m = 0; m < temp.length; m++) {
								if (temp[m] === currentChart) temp.splice(m, 1);
							}
						}
						for (var chart in temp)
							chartOptions += '<option value="' + temp[chart] + '">' + "Chart object ID " + temp[chart] + '</option>';

						chartsSelect.html(chartOptions).DUIsmartSelectBox('update');

						if (chartsSelect.hasClass('DUIsmartSelectBox'))
							chartsSelect.DUIsmartSelectBox('destroy');
						chartsSelect.DUIsmartSelectBox({
							'filter': true,
							'checkable': false,
							'height': 340,
							'width': 260
						});
					}
				});
			}
			else
				$('#multiEditCharts').html('').DUIsmartSelectBox('update');
		});

		chartsSelect.live('selected', function () {
			window.selectedChartFromUI = $(this).DUIsmartSelectBox('selected').toString();
			enableDisableBtn();
		});

		// Collapsable fieldsets
		$('#multiEditSettings').delegate('fieldset.expandable', 'click', function () {
			var collapseGroup = $(this).attr('data-collapse-group');
			if (collapseGroup !== undefined) {
				$(collapseGroup).find('fieldset.collapsable').removeClass('collapsable').addClass('expandable');
			}
			$(this).removeClass('expandable').addClass('collapsable');
		});

		$('#multiEditSettings').delegate('fieldset.collapsable > .advanced', 'click', function () {
			$(this).parent().removeClass('collapsable').addClass('expandable');
		});

		// Apply settings confirmation
		$("#btnMultiEditSave").unbind('click').bind('click', MultiEdit.ConfirmSettings);

		// Close Multi edit dialog
		$("#btnMultiEditCancel, #multiEditContainer .DUI-Setup-close").bind("click", MultiEdit.MultiEditClose);

	}

	function applySettings() {

		var curEditBox = $('.layoutElementAdminFocused');
		var sourceLayoutElementId = parseInt(curEditBox.attr("layoutelementid"));

		var selectedCharts = $('#multiEditCharts').DUIsmartSelectBox('selected');
		var currentReportId = Helpers.getReportID();
		var chartNumbers = [];
		$(selectedCharts).each(function (index) {
			chartNumbers.push(selectedCharts[index]);
		});
		var selectedInput = $(".DUI-custom-radio input[name='multiEditObjectsSelection']:checked").attr("value");
		var selectedObjects = [];
		$('#multiEditChart input:checked').each(function () {
			selectedObjects.push($(this).attr('id'));
		});
		var data = {
			bulkEditingType: window.elementType,
			currentReportId: currentReportId,
			elementIds: chartNumbers,
			sourceLayoutElementId: sourceLayoutElementId,
			selectedObjects: selectedObjects,
			selectedInput: selectedInput
		};
		//select custom selection after click on apply button
		$("#multiEditCustomSelection").click();
		Helpers.perfJSonCall({
			method: 'BulkEditObject',
			service: 'generalsettings',
			data: data,
			message: 'Saving charts settings',
			successCallback: function () {
				Storyboard.LayoutControls.showMessage('Success');
				MultiEdit.MultiEditClose();
				var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(curEditBox.attr('guid'));
				var layoutElementItem = Storyboard.LayoutDesigner.getLayoutElementItem(layoutElement);
				//load data groups in cache againg because once the object is saved the cache is deleted . And since we are not opening the chart through edit again we have to load it this way. 
				Storyboard.DataGroupLogic.LoadDataGroupsForLayoutElementItem(layoutElementItem, layoutElement, 'true');
				//	setTimeout(function () { Storyboard.LayoutControls.showMessage('Success'); }, 500);
			},
			failedCallback: function () {
				setTimeout(function () {
					Storyboard.LayoutControls.showMessage('Fail');
				}, 500);
			},
			fixCasing: true
		});
		$('.DUI-WINDOW-CLOSE').click();
		$("#multiEditCustomSelection").click();
	}

	function confirmSettingsHtml() {
		var selectedInput = $(".DUI-custom-radio input[name='multiEditObjectsSelection']:checked").attr("value");
		var reportsWithName = {};
		var i;
		for (i = 0; i < window.allReports.length; i++)
			reportsWithName[window.allReports[i].id] = window.allReports[i].name;

		var settingsHtml = '<div class="multiEditSettingsSelection cf">';
		for (var group in selectedSettings) {
			if (selectedSettings.hasOwnProperty(group)) {
				settingsHtml += '<div class="size-1-4">';

				if (group !== '') settingsHtml += '<p><strong>' + group.toUpperCase() + '</strong></p>';

				for (var fieldset in selectedSettings[group]) {
					if (selectedSettings[group].hasOwnProperty(fieldset)) {
						if (fieldset !== '') settingsHtml += '<p>' + fieldset + ':</p>';
						settingsHtml += '<ul><li>';
						settingsHtml += selectedSettings[group][fieldset].filter(function (item) { return item }).join('</li><li>');
						settingsHtml += '</li></ul>';
					}
				}
				settingsHtml += '</div>';
			}
		}
		settingsHtml += '</div>';
		var settingsHtml2 = '<div class="multiEditSettingsSelection cf">';
		settingsHtml2 += '</div>';
		settingsHtml2 += '<div class = "selectedReports size-1-6">' + '<p><strong> OBJECTS' + '</strong></p>';

		switch (selectedInput) {
			case "CustomSelection":
				for (i = 0; i < window.selectedChartsBulk.length; i++) {


					settingsHtml2 += '<ul><li>';
					settingsHtml2 += reportsWithName[window.chartsWithReportIds[window.selectedChartsBulk[i]]] + '/ Chart Object ID ' + window.selectedChartsBulk[i];
					settingsHtml2 += '</li></ul>';
				}
				break;
			case "AllInProject":
				settingsHtml2 += "All charts in the project.";
				break;
			case "AllInReport": settingsHtml2 += "All charts in the current report.";
				break;
			case "AllInReports": settingsHtml2 += "All charts in the current report and sub reports.";
				break;
		}

		settingsHtml2 += '</div>';
		settingsHtml += settingsHtml2;

		return settingsHtml;

	}

	function confirmSettings() {
		MultiEdit.ReadSettingsSelection();

		var selectedCharts = $('#multiEditCharts').DUIsmartSelectBox('selected');
		window.selectedChartsBulk.length = 0;
		$(selectedCharts).each(function (index) {
			window.selectedChartsBulk.push(selectedCharts[index]);
		});



		if ($.isEmptyObject(selectedSettings)) {
			Storyboard.LayoutControls.showError(locale.get('Please select settings to be applied.'));
			return;
		}

		var confirmHtml = '<p>' + locale.get('The following settings will be applied to the selected objects, do you want to continue?') + '</p>'
                        + '<div id = "SaveCurrentObject"><p>' + '<b>' + locale.get('[The current object will also be saved]') + '</b>' + '</p>'
						+ '<p style ="text-align: right">'
						+ '<input type = "button" class = "DUI-BUTTON DUIbutton" id = "btnCurrObjectCancel" value ="Cancel"></>'
                        + '<input type = "button" class = "DUI-BUTTON DUIbutton focused" style ="margin-left: 1em" id = "btnCurrObjectSaveTop" value ="Yes, apply settings"></>'
                        + '</p></div>'
						+ '</hr>';
		
		confirmHtml += MultiEdit.ConfirmSettingsHTML();

		new DUIwindow2({
			title: '<h2>Apply Settings</h2>',
			width: 740,
			height: 'auto',
			buttons: [{
				text: 'Yes, apply settings',
				focused: true,
				buttonId: 'btnCurrObjectSaveBottom',
				onClick: function () {
					//MultiEdit.ApplySettings();
				}
			}, {
				text: 'Cancel',
				onClick: function () {
					return false;
				}
				
			}],
			afterShow: function () {
				$("#btnCurrObjectSaveTop, #btnCurrObjectSaveBottom").bind('click', { closePopUp: 'false' }, Storyboard.GuiEvents.saveSettings);

				$("#btnCurrObjectCancel").bind('click', function () { $('.DUI-WINDOW-CLOSE').click(); });
			},
			html: confirmHtml,
			modal: true
		});
	}

	function confirmUndoBulkObject(undoValue) {

		new DUIwindow2({
			width: 320,
			closeButton: false,
			html: 'Do you really want to undo bulk edited objects?',
			buttons: [
						{
							text: 'Cancel',
							onClick: function () { return false; }
						},
						{
							text: 'Undo',
							focused: true,
							onClick: function () {
								Storyboard.LayoutControls.showLoadingBar("Undo is in process");
								$.when(undoBulkChanges(undoValue)).done(function (data) {
									$.when(getHistoryHtml()).done(function (result) {
										setTimeout(function () {
											var settingsHtml = '<p><strong> Time Stamp' + '</strong></p>';
											if (result.d.length > 0) {
												for (var i = 0; i < result.d.length; i++) {
													settingsHtml += '<ul><li>';
													settingsHtml += result.d[i].TimeStamp;
													settingsHtml += ' <div class ="undoHistory" style="display: inline-block;cursor:pointer" value="';

													settingsHtml += result.d[i].BulkId;
													settingsHtml += '" > Undo History </div>';
													settingsHtml += '</li></ul>';
												}
												$('.selectedReports').html(settingsHtml);
											} else {
												$('.selectedReports').html(settingsHtml);
											}
											Storyboard.LayoutControls.showMessage("The Undo operation was made successfully");
										}, 500);


									});
								});
								return false;
							}
						}
			],
		});
	}

	function getHistoryHtml() {
		var params = {
			method: "GetBulkEditingHistory",
			service: 'generalsettings',
			message: 'Retrieving Bulk History',
		};
		return Helpers.perfJSonCall(params);
	}

	function showHistory() {

		Storyboard.LayoutControls.showLoadingBar("Loading history");

		function openHistoryWindow(result) {
			var settingsHtml = '<div class="multiEditSettingsSelection cf">';
			settingsHtml += '</div>';
			settingsHtml += '<div class = "selectedReports size-1-6">' + '<p><strong> Time Stamp' + '</strong></p>';
			for (var i = 0; i < result.d.length; i++) {
				settingsHtml += '<ul><li>';
				settingsHtml += result.d[i].TimeStamp;
				settingsHtml += ' <div class ="undoHistory" style="display: inline-block;cursor:pointer" value="';

				settingsHtml += result.d[i].BulkId;
				settingsHtml += '" > Undo History </div>';
				settingsHtml += '</li></ul>';
			}
			settingsHtml += '</div>';

			new DUIwindow2({
				title: '<h2>History of bulk edited objects</h2>',
				width: 450,
				height: 'auto',
				cssClass: 'historyPopUp',
				buttons: [{
					text: 'Cancel',
					onClick: function () {
						return false;
					}
				}],
				html: settingsHtml,
				modal: false
			});

			Storyboard.LayoutControls.hideLoadingBar();
		}

		$.when(getHistoryHtml()).done(openHistoryWindow);
	}

	//Code for undo bulk history
	function undoBulkChanges(bulkId) {
		var params = {
			method: "UndoBulkEditing",
			data: {
				bulkId: bulkId
			},
			service: 'generalsettings',
			message: 'Bulk undo in progress',
		};
		return Helpers.perfJSonCall(params);
	}

	$(".undoHistory").live('click', function () {
		confirmUndoBulkObject(this.getAttribute('value'));
	});
	

	function getObjectsSelection() {
		$('#multiEditObjects input[name=multiEditObjectsSelection]:selected').val();
	}

	function getSettingsSelection() {
		return $.isEmptyObject(selectedSettings) ? null : selectedSettings;
	}

	function readSettingsSelection() {
		selectedSettings = {};
		$('#multiEditSettings .multiEditSettingsList input[type="checkbox"]:checked').each(function () {
			var group = $(this).closest('.multiEditSettingsGroup').find('> .settingsFieldsetLegend').text();
			var fieldset = $(this).closest('.multiEditSettingsFieldset').find('.settingsFieldsetLegend label').text();
			var setting = $(this).next('label').text();

			if (!selectedSettings[group])
				selectedSettings[group] = {};

			if (!selectedSettings[group][fieldset])
				selectedSettings[group][fieldset] = [];

			selectedSettings[group][fieldset].push(setting);



		});
	}

	function resetSelections() {
		$('#multiEditSettings input[type="checkbox"]').removeAttr('checked');
		$('#multiEditSettings .multiEditSettingsType').hide();
	}

	return {
		MultiEditAsDialog: multiEditAsDialog,
		MultiEditClose: multiEditClose,
		SetupType: setupType,
		ApplySettings: applySettings,
		ResetSelections: resetSelections,
		ReadSettingsSelection: readSettingsSelection,
		GetSettingsSelection: getSettingsSelection,
		GetObjectsSelection: getObjectsSelection,
		BindControls: bindControls,
		ConfirmSettings: confirmSettings,
		ConfirmSettingsHTML: confirmSettingsHtml,
		ShowHistory: showHistory,
		HistoryClose: historyClose
	};
}();